module.exports = __webpack_public_path__ + "static/media/artist.ddd3abc8.png";